import { FC } from 'react'

import { AssignmentRendererProps } from './AssignmentRenderer.types'
import { RendererQueryState, UploadedFilesSection } from '../common'
import { CertificateOfNeedsSection } from './shared/CertificateOfNeedsSection.component'
import { useAssignmentDetailDrawerWorkspaceId } from '../AssignmentDetailDrawer.context'
import { useGetCertificateOfNeedsDetails } from 'dataQueries/assignmentDetails.query'

/**
 * Assignment detail renderer for energy certificate of needs products.
 * Handles ProductType.ENERGY_CERTIFICATE_OF_NEED assignments.
 */
export const CertificateOfNeedsDetailsRenderer: FC<AssignmentRendererProps> = ({ assignment }) => {
  const workspaceId = useAssignmentDetailDrawerWorkspaceId()
  const { data, isLoading, isError, refetch } = useGetCertificateOfNeedsDetails(assignment.id, workspaceId)

  return (
    <RendererQueryState assignmentId={assignment.id} isLoading={isLoading} isError={isError} onRetry={refetch}>

      {!!data &&
        <CertificateOfNeedsSection data={data} />
      }

      <UploadedFilesSection assignmentId={assignment.id} />

    </RendererQueryState>
  )
}
